// models/EventModel.jsx
export default class EventModel {
    constructor(data = {}) {
        this.id = data.id ?? null;
        this.imgEven = data.img ?? "empty";             // map API -> model
        this.nomEven = data.title ?? "";               // map API -> model
        this.sousNomEven = data.subtitle ?? "";
        this.description = data.description ?? "";
        this.dateEven = data.date ?? null;
        this.nbr_jaime = data.likes ?? 0;
        this.nbr_vues = data.views ?? 0;
        this.nbr_clicks = data.clicks ?? 0;
        this.nbr_reserved = data.reserved ?? 0;
        this.site = data.site ?? null;

        // ATTRIBUTS RESTANTS POUR DÉTAILS ÉVENT
        this.user_id = data.user_id ?? null;
        this.duree = data.duree ?? "";
        this.prixEven = data.prixEven ?? "";
        this.category_id = data.category_id ?? null;
        this.videoEven = data.videoEven ?? "empty";
        this.fileEven = data.fileEven ?? "empty";
        this.codePostalEven = data.codePostalEven ?? "";
        this.villeEven = data.villeEven ?? "";
        this.rueEven = data.rueEven ?? "";
        this.nbr_place = data.nbr_place ?? 0;
        this.nbr_comment = data.nbr_comment ?? 0;
        this.type = data.type ?? "event";
        this.conditionReservation = data.conditionReservation ?? null;
        this.typeEvent = data.typeEvent ?? "Présentiel";
        this.noteEven = data.noteEven ?? null;
        this.isGratuit = data.isGratuit ?? 1;
        this.isParking = data.isParking ?? 0;
        this.isHandicap = data.isHandicap ?? 0;
        this.isAuditive = data.isAuditive ?? 0;
        this.isRestaurant = data.isRestaurant ?? 0;
        this.ref = data.ref ?? null;
        this.isVisited = data.isVisited ?? "non";
        this.is_active = data.is_active ?? true;

    }
}
